// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__epVD8","checkbox_block":"Checkbox_checkbox_block__ONAtc","active":"Checkbox_active__EHyLt"};